export var iconFontVersion = '3.15';
export var IconFontFileName = "audi-iconfont_".concat(iconFontVersion, ".woff2");
export var baseIconFontPath = "assets/webfonts/icon/".concat(IconFontFileName);